import { render, staticRenderFns } from "./Trades.vue?vue&type=template&id=6dae42fc&scoped=true"
import script from "./Trades.vue?vue&type=script&lang=js"
export * from "./Trades.vue?vue&type=script&lang=js"
import style0 from "./Trades.vue?vue&type=style&index=0&id=6dae42fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dae42fc",
  null
  
)

export default component.exports